<div class="content-camps content-camps-stats content-camps-stats--provider">
    <router-outlet></router-outlet>
</div>
